import React, { useState, useEffect } from 'react';
import { Phone, MessageSquare, ShoppingCart, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const MobileCTABar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isDismissed, setIsDismissed] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  // Determine which division we're on for colors
  const isPropertyServices = location.pathname.startsWith('/ps');
  const primaryColor = isPropertyServices ? '#456CAC' : '#456CAC';
  const primaryColorDark = isPropertyServices ? '#3A5A91' : '#3A5A91';

  // Phone numbers based on division
  const phoneNumber = '4039865484';
  const quoteLink = isPropertyServices ? '/ps' : '/fence/contractors';

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Hide when scrolling down, show when scrolling up
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Don't show on admin pages or if dismissed
  if (location.pathname.startsWith('/admin') || isDismissed) {
    return null;
  }

  // Only show on mobile/tablet (handled via CSS)
  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-40 lg:hidden transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      {/* Dismiss button */}
      <button
        onClick={() => setIsDismissed(true)}
        className="absolute -top-8 right-4 p-1.5 bg-white/90 backdrop-blur-sm rounded-full shadow-md text-slate-500 hover:text-slate-700"
        aria-label="Dismiss"
        data-testid="mobile-cta-dismiss"
      >
        <X className="w-4 h-4" />
      </button>

      {/* CTA Bar */}
      <div 
        className="bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]"
      >
        <div className="flex items-stretch">
          {/* Call Now Button */}
          <a
            href={`tel:${phoneNumber}`}
            className="flex-1 flex items-center justify-center gap-2 py-4 text-white font-semibold text-sm transition-all active:scale-95"
            style={{ backgroundColor: primaryColor }}
            data-testid="mobile-cta-call"
          >
            <Phone className="w-5 h-5 animate-pulse" />
            <span>Call Now</span>
          </a>

          {/* Get Quote Button - Using Link for proper routing */}
          <Link
            to={quoteLink}
            className="flex-1 flex items-center justify-center gap-2 py-4 font-semibold text-sm border-l border-r transition-all active:scale-95"
            style={{ backgroundColor: primaryColorDark, color: 'white', borderColor: 'rgba(255,255,255,0.2)' }}
            data-testid="mobile-cta-quote"
          >
            <MessageSquare className="w-5 h-5" />
            <span>Get Quote</span>
          </Link>

          {/* Shop Button */}
          <a
            href="https://mccsys.ca/store/central-alberta-fencing-inc-la24fw"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 py-4 bg-slate-800 text-white font-semibold text-sm transition-all active:scale-95"
            data-testid="mobile-cta-shop"
          >
            <ShoppingCart className="w-5 h-5" />
            <span>Shop</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MobileCTABar;
